export default __webpack_public_path__ + "static/team4-a173f6b45cbf8f3527f4a706200da300.jpg";